import { ElementType, IElement } from "./model/IProcessData";
import { USE_SIGNAL_REHYDRATION_MODE } from "./model/ElementFactory";

export function getIntermediateCatchEventEventDefinitionType(element: BpmnJsElement, existingParameters?: IElement): ElementType | null {

    // IntermediateCatchEvent type is derived from its event definition
    if (element && element.type === "bpmn:IntermediateCatchEvent") {
        
        const eventDefinition = element.businessObject.eventDefinitions?.[0]?.$type;

        if (eventDefinition === "bpmn:TimerEventDefinition") {
            return ElementType.ScheduledRehydration;
        }

        // As both SignalRehydration and HydrationPoint have same bpmn:MessageEventDefinition,
        // USE_SIGNAL_REHYDRATION_MODE parameter is used to derive actual type
        if (eventDefinition === "bpmn:MessageEventDefinition") {
            const signalRehydration = (element as any)?.[USE_SIGNAL_REHYDRATION_MODE] === true || 
                (existingParameters && existingParameters?.parameters?.[USE_SIGNAL_REHYDRATION_MODE]?.value === true);

            return signalRehydration ? ElementType.SignalRehydration : ElementType.HydrationPoint;
        }

        // Default to Catch to maintain backward compatibility (eventDefinition === bpmn:SignalEventDefinition)
        return ElementType.Catch; 
    }

    return null;
}